<template>
  <el-row :gutter="16">
    <el-form :model="dataForm" :rules="formRules" size="small" ref="form" label-width="130px" :disabled="disableForm">
      <el-col v-for="(config, index) in formConfig" :key="index" :span="config.span || 24">
        <el-form-item :label="config.label" :prop="config.prop" v-if="!config.hide">
          <template v-if="!disableForm">
            <div class="d-flex flex-column">
              <div>

                <!-- 下拉选择 -->
                <el-select v-if="config.type === 'select'" v-model="dataForm[config.prop]" :value-key="config.valueKey"
                  :placeholder="config.placeholder || '请选择'" filterable v-bind="config.property"
                  :disabled="config.disable" clearable>
                  <el-option v-for="(option, indexs) in config.options" :key="indexs" :label="option.label"
                    :disabled="option.disabled" :value="option.id"></el-option>
                </el-select>

                <!-- 级联选择 -->
                <el-cascader v-if="config.type === 'cascader'" v-model="dataForm[config.prop]" :options="config.options"
                  :placeholder="config.placeholder || '请选择'" v-bind="config.property"></el-cascader>

                <!-- 单选框 -->
                <el-radio-group v-if="config.type === 'radio'" v-model="dataForm[config.prop]"
                  :disabled="config.disable" v-bind="config.property">
                  <el-radio :label="option.id" v-for="option in config.options" :key="option.id">{{ option.label
                    }}</el-radio>
                </el-radio-group>

                <!-- 多选框 -->
                <el-checkbox-group v-if="config.type === 'checkbox'" v-model="dataForm[config.prop]"
                  :disabled="config.disable" v-bind="config.property">
                  <el-checkbox :label="option.id" v-for="option in config.options" :key="option.id">{{ option.label
                    }}</el-checkbox>
                </el-checkbox-group>
                <!-- 日期选择 -->
                <el-date-picker v-if="config.type === 'date'" v-model="dataForm[config.prop]" v-bind="config.property"
                  type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :disabled="config.disable">
                </el-date-picker>
                <!-- 输入框 -->
                <el-input v-if="config.type === 'input'" v-model="dataForm[config.prop]" v-bind="config.property"
                  :placeholder="config.placeholder || '请输入'" :disabled="config.disable"></el-input>
                <!-- 文本框 -->
                <el-input v-if="config.type === 'textarea'" :maxlength="config.maxlength" type="textarea" :rows="4"
                  v-bind="config.property" v-model="dataForm[config.prop]" :placeholder="config.placeholder || '请输入'" />
                <!-- 数字输入 -->
                <el-input-number v-if="config.type === 'number'" v-bind="config.property"
                  v-model="dataForm[config.prop]" controls-position="right" :min="config.min"
                  :max="config.max || 999999" :disabled="config.disable"></el-input-number>
                <!-- 文件上传 -->
                <my-upload v-if="config.type === 'upload'" v-model="dataForm[config.prop]" v-bind="config.property"
                  :disabled="config.disable">
                  <!-- 自定义上传按钮 -->
                  <el-button slot="upload-button" size="small" type="primary">自定义上传按钮</el-button>
                  <!-- 自定义提示信息 -->
                  <div slot="tip">
                    <div v-html="config.tip"></div>
                  </div>
                </my-upload>
                <div v-if="!config.type" class="">
                  <slot :name="config.prop"></slot>
                </div>
              </div>
              <span v-if="config.tips">
                {{ config.tips }}</span>
            </div>

          </template>
          <!-- 禁用状态，只展示文字 -->
          <span v-else>
            <div v-if="!config.type" class="">
              <slot :name="config.prop"></slot>
            </div>
            <template v-else-if="config.type === 'select' || config.type === 'cascader' || config.type === 'radio'">
              {{ getLabelText(config) }}
            </template>
            <template v-else-if="config.type === 'checkbox'">
              {{ dataForm[config.prop] }}
            </template>
            <template v-else>
              <div v-if="config.prop == 'idCard'" class="d-flex flex-align-center">
                <span class="idCard"> {{ desensitizationNum(dataForm[config.prop]) }}</span>
                <i class="el-icon-view mg-lef20 cs-pit" @mouseenter="showNum = false" @mouseleave="showNum = true"></i>
              </div>
              <span v-else>{{ dataForm[config.prop] }}</span>

            </template>
          </span>
        </el-form-item>
      </el-col>
      <slot></slot>
      <!-- 提交按钮 -->
      <el-form-item v-if="isShowBtn">
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import MyUpload from "@/components/myUpload.vue";
import { numberDesensitization } from "@/utils/util.js";
// this.formConfig.dataForm.idCard=numberDesensitization(row.idCard,4,3)

export default {
  components: {
    MyUpload,
  },
  props: {
    formConfig: {
      type: Array,
      required: true,
    },
    isShowBtn: {
      type: Boolean,
      default: false,
    },
    disableForm: {
      type: Boolean,
      default: false,
    },
    dataForm: {
      type: Object,
      required: {},
    },
    formRules: {
      type: Object,
      required: {},
    },
  },
  data () {
    return {
      showNum: true,
    };
  },
  methods: {
    desensitizationNum (num) {
      if (this.showNum) {
        return numberDesensitization(num, 4, 3)
      } else {
        return num
      }
    },
    getLabelText (config) {
      const selectedValues = Array.isArray(this.dataForm[config.prop]) ? this.dataForm[config.prop] : [this.dataForm[config.prop]];

      const selectedLabels = selectedValues.map(value => {
        const selectedLabel = this.findLabelInTree(config, config.options, value);
        return selectedLabel ? selectedLabel : '无';
      });
      return selectedLabels.length > 0 ? selectedLabels.join(', ') : '无';
    },
    findLabelInTree (config, tree, value) {
      for (const node of tree) {
        if (config.property && config.property.props && config.property.props.value) {
          if (node[config.property.props.value] == value) {
            return node[config.property.props.label];
          }
        } else {
          if (node.id == value) {
            return node.label;
          }
        }

        if (node.children && node.children.length > 0) {
          const childLabel = this.findLabelInTree(config, node.children, value);
          if (childLabel) {
            return childLabel;
          }
        }
      }

      return null;
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交表单逻辑
          console.log("Form submitted!");
        } else {
          console.log("Form validation failed!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select,
.el-input,
.el-cascader {
  width: 100%;
}

.idCard {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/myForm.vue